import React, { useContext, useEffect } from 'react';
import withApollo from '../lib/apollo';
import LoginComponent from '../components/LoginSignup/Login';
import { UserContext } from '../components/UserProvider';
import { Router } from '../routes.mjs';
import { useSiteContext } from '../components/SiteContext';

export const Login = () => {
  const { user } = useContext(UserContext);
  const { dashboard } = useSiteContext();

  useEffect(() => {
    if (user) {
      Router.replaceRoute('index');
    }
  }, [user]);

  return (
    <LoginComponent showBreadcrumbs={!dashboard} />
  );
};

export default withApollo(Login);
